module.exports = __webpack_public_path__ + "static/media/CGbanner.ade50611.jpg";